module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="coming-soon">\n	<div class="text-block">\n		<h5>The NRL Fantasy Season is now complete</h5>\n		<p>\n			You are unable to make any further adjustments to your team.\n		</p>\n	</div>\n</div>';
}
return __p;
};
